import { render, staticRenderFns } from "./Reload.vue?vue&type=template&id=5b7cdb16&"
import script from "./Reload.vue?vue&type=script&lang=ts&"
export * from "./Reload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b7cdb16')) {
      api.createRecord('5b7cdb16', component.options)
    } else {
      api.reload('5b7cdb16', component.options)
    }
    module.hot.accept("./Reload.vue?vue&type=template&id=5b7cdb16&", function () {
      api.rerender('5b7cdb16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/apps/Reload.vue"
export default component.exports